var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000099;stroke-width:14.2105;stroke-miterlimit:10;}\n\t.st1{fill:#000099;}\n\t.st2{fill:none;stroke:#000099;stroke-width:14;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#000099;stroke-width:12;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000099;stroke-width:11;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000099;stroke-width:10;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.38,84.19c0,31.72-42.38,75.88-42.38,75.88s-42.39-44.15-42.39-75.88c0-24.44,17.94-44.26,42.39-44.26 C124.45,39.93,142.38,59.75,142.38,84.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,65.34c-5.62,0-10.17,4.55-10.17,10.17c0,5.62,4.56,10.17,10.17,10.17c5.62,0,10.17-4.55,10.17-10.17 C110.17,69.89,105.62,65.34,100,65.34L100,65.34z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3c15c0a07dc68b1494f8371e06895bd8.svg";
export { ForwardRef as ReactComponent };